import React from "react";
import { isPortrait, isLandscape } from "@/modules/commonMobile";
import { isIPhone, isIOS, isIPadOS, isIPad } from "@/modules/iOSDetection";
import MobileDetect from "mobile-detect";
import { hideLoadingScreen } from "@/modules/loading";

export default class NavigatorTest extends React.Component {
    md: MobileDetect;

    constructor() {
        super({});

        this.md = new MobileDetect(window.navigator.userAgent);
    }

    componentDidMount() {
        hideLoadingScreen();
    }

    render() {
        const mobile = this.md.mobile();

        const IPhone = isIPhone();
        const IOS = isIOS();
        const IPad = isIPad();
        const IPadOS = isIPadOS();
        

        const Portrait = isPortrait();
        const Landscape = isLandscape();

        return (
            <div style={{color: "white"}}>
                User agent: {navigator.userAgent}<br/>
                Platform: {navigator.platform}<br/>
                <br/>
                mobile: {mobile + ""}<br/>
                <br/>
                iPhone: {IPhone + ""}<br/>
                iOS: {IOS + ""}<br/>
                iPad: {IPad + ""}<br/>
                iPadOS: {IPadOS + ""}<br/>
                { // iPadPro: {IPadPro}<br/>
                }
                <br/>
                Portrait: {Portrait + ""}<br/>
                Landscape: {Landscape + ""}<br/>
            </div>
        );
    }
}